import React from 'react';
import { Helmet } from 'react-helmet-async'
import { RoleBasedGuard } from 'src/auth/guard';
import MstListView from 'src/sections/Masters/SubscrSiteList'


export default function SubscriberSite() {
return (
    <>
        <Helmet>
        <title> MeruDesk: Subscriber Site </title>
      </Helmet> 
      <RoleBasedGuard hasContent screenName="Master" currentPage="list" sx={{ py: 10 }}>
      <MstListView/>
      </RoleBasedGuard>
    </>
  )
}



